module.exports = __webpack_public_path__ + "plp/shop-men.4d2855.jpg";